"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSubjectHander = exports.getUnderlyingNode = void 0;
var data_model_1 = require("@rdfjs/data-model");
var addObjectToDataset_1 = require("./helperFunctions/addObjectToDataset");
var getProxyFromDataset_1 = require("./helperFunctions/getProxyFromDataset");
var deleteFromDataset_1 = require("./helperFunctions/deleteFromDataset");
exports.getUnderlyingNode = Symbol("getUnderlyingNode");
function createSubjectHander(dataset, contextUtil, proxyCreator) {
    return {
        get: function (target, key) {
            if (key === exports.getUnderlyingNode) {
                return target["@id"];
            }
            return (0, getProxyFromDataset_1.getProxyFromDataset)(target, key, dataset, contextUtil, proxyCreator);
        },
        getOwnPropertyDescriptor: function (target, key) {
            return {
                value: (0, getProxyFromDataset_1.getProxyFromDataset)(target, key, dataset, contextUtil, proxyCreator),
                writable: true,
                enumerable: true,
                configurable: true,
            };
        },
        ownKeys: function (target) {
            var subject = target["@id"];
            var tripleDataset = dataset.match(subject);
            var keys = new Set(["@id"]);
            tripleDataset.toArray().forEach(function (quad) {
                keys.add(contextUtil.iriToKey(quad.predicate.value));
            });
            return Array.from(keys);
        },
        set: function (target, key, value) {
            var _a;
            if (key === "@id" && typeof value === "string") {
                var currentSubjectQuads = dataset.match(target["@id"]).toArray();
                var newSubjectQuads = currentSubjectQuads.map(function (curQuad) {
                    return (0, data_model_1.quad)((0, data_model_1.namedNode)(value), curQuad.predicate, curQuad.object, curQuad.graph);
                });
                currentSubjectQuads.forEach(function (curQuad) { return dataset.delete(curQuad); });
                dataset.addAll(newSubjectQuads);
                var currentObjectQuads = dataset
                    .match(undefined, undefined, target["@id"])
                    .toArray();
                var newObjectQuads = currentObjectQuads.map(function (curQuad) {
                    return (0, data_model_1.quad)(curQuad.subject, curQuad.predicate, (0, data_model_1.namedNode)(value), curQuad.graph);
                });
                currentObjectQuads.forEach(function (curQuad) { return dataset.delete(curQuad); });
                dataset.addAll(newObjectQuads);
                target["@id"] = (0, data_model_1.namedNode)(value);
            }
            (0, addObjectToDataset_1.addObjectToDataset)((_a = { "@id": target["@id"] }, _a[key] = value, _a), dataset, contextUtil, new Set(), true);
            return true;
        },
        deleteProperty: function (target, key) {
            return (0, deleteFromDataset_1.deleteValueFromDataset)(target, key, dataset, contextUtil);
        },
    };
}
exports.createSubjectHander = createSubjectHander;
